import { render } from "./Index.vue?vue&type=template&id=60987dc9"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=60987dc9&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__